import { Button, Clickable, H2, ImageLockup, PortableText, TypeWrapper } from '@ahmdigital/ui';
import { get, kebabCase, map } from 'lodash/fp';
import React from 'react';

import getHasSmallDetailsVariant from './utils/get-has-small-details-variant';
import styles from './styles.module.sass';
import WrappedSection from '../wrapped-section';

const importanceVariant = {
  high: ['purple'],
  low: ['border', 'white'],
  medium: null,
};

type HowItWorksSectionProps = {
  cta?: {
    importance: string;
    name: string;
    url: string;
  };
  steps: {
    details: string | unknown[];
    image?: {
      src: string;
    };
    title: string;
    titlePrefix?: string;
  }[];
  title: string | unknown[];
};

const HowItWorksSection = ({ cta, steps, title }: HowItWorksSectionProps) => {
  const hasSmallDetailsVariant = getHasSmallDetailsVariant({ steps });
  const detailsVariant = hasSmallDetailsVariant ? styles.smallDetails : styles.largeDetails;
  return (
    <WrappedSection spacerSize={1} withBorder withWide>
      <div className={styles.container}>
        <H2 variant={['marginBottomSpacer3', 'center']}>
          <PortableText source={title} />
        </H2>
        {map(({ details, image, title: stepTitle, titlePrefix, urlObject }) => {
          const linkText = get('name')(urlObject);
          const linkUrl = get('url')(urlObject);
          return (
            <div className={styles.step} key={kebabCase(stepTitle)}>
              <ImageLockup
                imageSrc={get('src')(image)}
                title={stepTitle}
                titlePrefix={titlePrefix}
                variant={['simpleBit', styles.imageLockup]}
              >
                <PortableText variant={detailsVariant} source={details} />
                {linkText && linkUrl && (
                  <Clickable to={linkUrl} variant={detailsVariant}>
                    {linkText}
                  </Clickable>
                )}
              </ImageLockup>
            </div>
          );
        })(steps)}
        {cta && cta.url && cta.name && (
          <TypeWrapper variant="center">
            {/* @ts-expect-error - Automatic, Please fix when editing this file */}
            <Button to={cta.url} variant={importanceVariant[cta.importance]}>
              {cta.name}
            </Button>
          </TypeWrapper>
        )}
      </div>
    </WrappedSection>
  );
};

HowItWorksSection.defaultProps = {
  cta: null,
};

export default HowItWorksSection;
